import "../../styles/product-detail.css";
import Footer from "../../components/footer";
import Header from "../../components/header";

function Hostcoman() {
  return (
    <div>
      <Header />
      <div className="product-details">
        <div className="details-heading">
          <h1>HOSTCOMAN</h1>
          <p>Empowering Host Communities with Compliance & Transparency.</p>
        </div>
        <div className="details-body">
          <p>
            A digital platform for Licensees, Regulators, and Stakeholders to
            streamline Host Community Development Trust reporting, ensure
            transparency, and drive sustainable growth in Nigeria's oil and gas
            host communities.
          </p>
          <p>
            HOSTCOMAN is a digital enterprise solution designed to simplify
            compliance, foster trust, and drive sustainable development in
            Nigeria's oil and gas host communities. Built for Licensees,
            Regulators, and Stakeholders, it streamlines Host Community
            Development Trust (HCDT) reporting, monitoring, and data
            management—bridging the gap between the industry and its host
            communities.
          </p>
          <p>
            By promoting transparency, accountability, and equitable resource
            distribution, HOSTCOMAN transforms resources into real opportunities
            for long-term community growth.
          </p>
        </div>
        <div className="details-features">
          <p>
            <span>Key Benefits</span>
          </p>
          <ol>
            <li>
              <p>
                Sustainable Growth: Fosters prosperity and long-term development
                in host communities.
              </p>
            </li>
            <li>
              <p>
                Socio-Economic Impact: Ensures direct social and economic
                benefits from petroleum operations.
              </p>
            </li>
            <li>
              <p>
                Data Security & Trust: Enables peaceful and transparent
                relationships between licensees and host communities.
              </p>
            </li>
            <li>
              <p>
                Community Support: Establishes a framework to strengthen host
                community development initiatives.
              </p>
            </li>
          </ol>
        </div>
        <div className="details-body">
          <p>Why HOSTCOMAN?</p>
          <p>
            Nigeria's oil and gas sector holds immense potential—but true
            progress comes when host communities share in that prosperity.
            HOSTCOMAN is the digital bridge that ensures fairness, compliance,
            and transparency, empowering all stakeholders to achieve sustainable
            development together.
          </p>
        </div>
        <div className="details-features">
          <p>Built on Transparency and Sustainability</p>
          <p>
            HOSTCOMAN was created with a clear mission: to ensure host
            communities receive their rightful benefits from Nigeria's energy
            wealth. Our platform:
          </p>
          <ol>
            <li>
              <p>Simplifies regulatory compliance</p>
            </li>
            <li>
              <p>Facilitates transparent fund management</p>
            </li>
            <li>
              <p>Promotes equitable development initiatives</p>
            </li>
          </ol>
        </div>
        <div className="details-features">
          <p>
            <span>License-Based Model</span>
          </p>
          <p>
            HostComan follows a flexible licensed based pricing structure to
            meet the diverse needs of organisations and regulatory bodies.
          </p>
          <ol>
            <li>
              <p>
                Basic license: Ideal for small organisations and single
                communities
              </p>
            </li>
            <li>
              <p>
                Standard license: For medium-sized enterprises managing multiple
                communities
              </p>
            </li>
            <li>
              <p>
                Enterprise license: Comprehensive package for large-scale
                operations, including advanced reporting and integrations
              </p>
            </li>
            <li>
              <p>
                Perpetual License: A one-time, upfront payment option that
                grants the user unlimited access with guaranteed support and
                updates for 10 years. Renewable for support and update ONLY
                after 10 years.
              </p>
            </li>
          </ol>
        </div>
        <p className="details-cta">Request a quote…</p>
      </div>
      <Footer />
    </div>
  );
}

export default Hostcoman;
